import { MapPin, Mountain } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

const Location = ({
  image,
  title,
  subtitle,
  description,
  subDescription,
  position,
  height,
  fit = "cover",
  location,
  attitude,
}) => {
  const isLeft = position === "left";
  const isContain = fit === "contain";
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-10">
      <div
        style={{ "--item-h": `${height}px` }}
        className={`w-full h-[260px] sm:h-[380px] md:h-[500px] lg:h-[var(--item-h)] lg:col-span-5 ${
          isLeft ? "lg:order-1" : "lg:order-2"
        } ${isContain ? "bg-[#fbfbfb]" : ""}`}
      >
        <img
          src={image}
          alt={title}
          className={`w-full h-full ${isContain ? "object-contain" : "object-cover"}`}
        />
      </div>
      <div
        className={`flex justify-center items-center lg:col-span-5 ${
          isLeft ? "lg:order-2" : "lg:order-1"
        }`}
      >
        <div className="p-6 sm:p-10 lg:p-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 text-[#223746] lg:w-2/3">
            {title}
          </h2>
          {subtitle && (
            <p className="text-lg text-[#223746] font-semibold mb-4">
              {subtitle}
            </p>
          )}
          <p className="mt-5 text-[#223746] text-sm sm:text-base">
            {description}
          </p>
          {subDescription && (
            <p className="mt-4 text-[#223746] text-sm sm:text-base">
              {subDescription}
            </p>
          )}
          <div className="flex mt-5 gap-4 items-center justify-between flex-wrap">
            <div className="flex items-center gap-2 text-sm text-[#223746] font-semibold">
              <Mountain size={18} className="text-yellow-600" />
              <span className="text-yellow-600">{attitude}</span>
              <span>{t("common.altitude")}</span>
            </div>
            <div className="flex items-center gap-2 text-sm lg:text-lg font-bold text-[#223746]">
              <MapPin size={18} className="text-yellow-600" />
              <span>{location}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Location;
